<template>
  <div class="container-fluid">
    <div class="row">
      <!-- Sidebar ocupa el 20% -->
      <div class="col-2 bg-dark">
        <SidebarView />
      </div>
      <!-- Contenido ocupa el 80% -->
      <div class="col-10">
        <router-view />
      </div>
    </div>
  </div>
</template>
<script>
  import SidebarView from '../components/Sidebar'

  export default {
    name: 'App',
    components: {
      SidebarView,
    },
  }
</script>

